import React from 'react'
import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. EMISION' htmlFor='input-fechaEmision' md={4} />
      <Col md={8}>
        <Field name='fechaEmision'>
          {({ field }) => <Form.InputDate {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-fechaEmision' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
